import React from "react";

import "../Styles/Footer.css";

function Footer() {
  return (
    <div className="footer">
      <p> &copy; 2021 Always Hungry @Besquare Deriv</p>
    </div>
  );
}

export default Footer;
